<template>
  <div class="add-update-container">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="100px">
      <el-form-item :label="$t('vipRule.vipLevel')" prop="viplevel">
        <el-input v-model="dataForm.viplevel" :placeholder="$t('vipRule.inputVipLevel')" clearable></el-input>
      </el-form-item>
      <el-form-item :label="$t('vipRule.discount')" prop="discount">
        <el-input-number v-model="dataForm.discount" :min="0" :max="1" :precision="2" :step="0.1" :placeholder="$t('vipRule.inputDiscount')"></el-input-number>
      </el-form-item>
      <el-form-item :label="$t('vipRule.price')" prop="amount">
        <el-input-number v-model="dataForm.amount" :min="0" :max="99999999" :precision="2" :step="1" :placeholder="$t('vipRule.inputPrice')"></el-input-number>
      </el-form-item>
      <el-form-item :label="$t('vipRule.duration')" prop="duration">
        <el-input-number v-model="dataForm.duration" :min="1" :max="3650" :placeholder="$t('vipRule.inputDuration')"></el-input-number>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm()">{{ !dataForm.id ? $t('vipRule.confirmAdd') : $t('vipRule.confirmEdit') }}</el-button>
        <el-button @click="cancel()">{{ $t('common.cancel') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    parent: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dataForm: {
        id: 0,
        viplevel: '',
        discount: 0.0,
        amount: 0.00,
        duration: 1,
        createdtime: null,
        updatedtime: null
      },
      dataRule: {
        viplevel: [
          { required: true, message: this.$t('vipRule.vipLevelRequired'), trigger: 'blur' }
        ],
        discount: [
          { required: true, message: this.$t('vipRule.discountRequired'), trigger: 'blur' }
        ],
        amount: [
          { required: true, message: this.$t('vipRule.priceRequired'), trigger: 'blur' }
        ],
        duration: [
          { required: true, message: this.$t('vipRule.durationRequired'), trigger: 'blur' }
        ]
      },
      type: ''
    }
  },
  methods: {
    init(id, type) {
      this.dataForm.id = id || 0;
      this.type = type || '';
      if (this.dataForm.id) {
        this.$http({
          url: `viprule/info/${this.dataForm.id}`,
          method: 'get'
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.dataForm = data.data;
          }
        });
      }
    },
    // 表单提交
    submitForm() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: `viprule/${!this.dataForm.id ? 'save' : 'update'}`,
            method: 'post',
            data: JSON.parse(JSON.stringify(this.dataForm))
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.$message({
                message: this.$t('vipRule.operationSuccess'),
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.parent.showFlag = true;
                  this.parent.addOrUpdateFlag = false;
                  this.parent.getDataList();
                }
              });
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      });
    },
    // 取消
    cancel() {
      // this.parent.showFlag = true;
      // this.parent.addOrUpdateFlag = false;
      if (this.parent) {
        this.parent.showFlag = true;
        this.parent.addOrUpdateFlag = false;
      } else {
        console.error("Parent component not found");
      }
    }
  }
}
</script>